/**
 * Authentication utilities for WebSocket connections
 */

/**
 * Generate authentication token for WebSocket connection
 * Uses client ID with timestamp, hex-encoded for security
 */
export function generateAuthToken(clientId: string): string {
  const timestamp = new Date().toISOString();
  const clientIdTimestamp = `${clientId}:${timestamp}`;

  // Convert to hex encoding for secure transmission
  const hashedAuth = Array.from(new TextEncoder().encode(clientIdTimestamp))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return `auth-${hashedAuth}`;
}
